import React from "react";
import { Link } from "react-router-dom";
import "./HowToUse.css";

const YOUTUBE_EMBED_ID = "rIGPacma5E0";

function HowToUse() {
  return (
    <section className="how-to-use" aria-labelledby="how-to-use-heading">
      <div className="how-to-use-inner">
        <h2 id="how-to-use-heading" className="how-to-use-title">
          How to use WillAlwaysLoveU
        </h2>
        <p className="how-to-use-intro">
          See how simple it is to choose a plan, create a memorial, and order an
          optional picture frame. The short video below walks you through our
          pricing and what each option includes.
        </p>
        <div className="how-to-use-video-wrap">
          <iframe
            title="WillAlwaysLoveU — plans and how to get started"
            src={`https://www.youtube.com/embed/${YOUTUBE_EMBED_ID}`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
        <p className="how-to-use-footer">
          Ready to begin?{" "}
          <Link to="/pricing">View pricing</Link>
          {" · "}
          <Link to="/contactus">Contact us</Link> if you have questions.
        </p>
      </div>
    </section>
  );
}

export default HowToUse;
